import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { SpaDataProvider } from "./context/SpaDataContext";
import { BookingProvider } from "./context/BookingContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";
import Home from "./pages/Home";
import Therapists from "./pages/Therapists";
import TherapistDetail from "./pages/TherapistDetail";
import Massages from "./pages/Massages";
import MassageDetail from "./pages/MassageDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Candidaturas from "./pages/Candidaturas";
import Promocoes from "./pages/Promocoes";
import Precos from "./pages/Precos";
import { Toaster } from "./components/ui/sonner";
import { AgeGate } from "./components/AgeGate";
import { ThemeProvider } from "./context/ThemeContext";
import { AdminAuthProvider } from "./admin/AdminAuthContext";
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import AdminTherapists from "./admin/AdminTherapists";
import AdminMassages from "./admin/AdminMassages";
import AdminApplications from "./admin/AdminApplications";
import AdminSpacePhotos from "./admin/AdminSpacePhotos";
import AdminNewsletter from "./admin/AdminNewsletter";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import CookiePolicy from "./pages/legal/CookiePolicy";
import TermsOfService from "./pages/legal/TermsOfService";
import { CookieBanner } from "./components/CookieBanner";
import ErrorBoundary from "./components/ErrorBoundary";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const Shell = () => {
  const { pathname } = useLocation();
  const isPanel = pathname.startsWith("/painel") || pathname.startsWith("/admin");
  return (
    <>
      <ScrollToTop />
      {!isPanel && <AgeGate />}
      {!isPanel && <Navbar />}
      <main>
        <ErrorBoundary resetKey={pathname}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terapeutas" element={<Therapists />} />
          <Route path="/terapeutas/:slug" element={<TherapistDetail />} />
          <Route path="/massagens" element={<Massages />} />
          <Route path="/massagens/:slug" element={<MassageDetail />} />
          <Route path="/sobre" element={<About />} />
          <Route path="/contactos" element={<Contact />} />
          <Route path="/candidaturas" element={<Candidaturas />} />
          <Route path="/promocoes" element={<Promocoes />} />
          <Route path="/precos" element={<Precos />} />
          <Route path="/privacidade" element={<PrivacyPolicy />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/termos" element={<TermsOfService />} />
          <Route path="/painel/login" element={<AdminLogin />} />
          <Route path="/painel" element={<AdminLayout />}>
            <Route index element={<AdminTherapists />} />
            <Route path="massagens" element={<AdminMassages />} />
            <Route path="candidaturas" element={<AdminApplications />} />
            <Route path="newsletter" element={<AdminNewsletter />} />
            <Route path="espaco" element={<AdminSpacePhotos />} />
          </Route>
          {/* Backwards-compat: old /admin URLs → /painel */}
          <Route path="/admin/login" element={<Navigate to="/painel/login" replace />} />
          <Route path="/admin" element={<Navigate to="/painel" replace />} />
          <Route path="/admin/massagens" element={<Navigate to="/painel/massagens" replace />} />
          <Route path="/admin/candidaturas" element={<Navigate to="/painel/candidaturas" replace />} />
          <Route path="/admin/*" element={<Navigate to="/painel" replace />} />
        </Routes>
        </ErrorBoundary>
      </main>
      {!isPanel && <Footer />}
      {!isPanel && <FloatingWhatsApp />}
      {!isPanel && <CookieBanner />}
    </>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <ThemeProvider>
          <LanguageProvider>
          <SpaDataProvider>
            <BookingProvider>
              <AdminAuthProvider>
                <Shell />
                <Toaster position="top-right" theme="dark" />
              </AdminAuthProvider>
            </BookingProvider>
          </SpaDataProvider>
          </LanguageProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
